import { T } from "../../../styles/Theme";

export const CheckOrange = () => {
  return (
    <svg width="12" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.75 4.75 8.5 11 1"
        stroke={T.blue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
